import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { LogIntegracaoService } from '../../../shared/services/apis/integracao/log-integracao.service';
import { LogIntegracaoStruct } from '../../../shared/services/structs/integracao/log-integracao.struct';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { GetLogIntegracaoResponse } from '../../../shared/services/responses/integracao/get-log-integracao.response';
import { Clipboard, ClipboardModule } from '@angular/cdk/clipboard';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderComponent } from '../../../shared/components/header/header.component';

@Component({
    selector: 'app-log-integracao-detalhe',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatIconModule,
        LoadingBoxComponent,
        MatTooltipModule,
        ClipboardModule,
        HeaderComponent
    ],
    templateUrl: './log-integracao-detalhe.component.html',
    styleUrls: ['./log-integracao-detalhe.component.css']
})
export class LogIntegracaoDetalhesComponent implements OnInit {
    public moduloEnum = ModuloEnum.Integracao;
    public funcionalidadeEnum = FuncionalidadeEnum.Integracao_LogIntegracao; // Ajuste se necessário

    public _isLoading = true;
    public log: LogIntegracaoStruct | null = null;
    public requestJsonFormatado: string = '';
    public responseJsonFormatado: string = '';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private logIntegracaoService: LogIntegracaoService,
        private alertService: AlertService,
        private clipboard: Clipboard
    ) { }

    ngOnInit(): void {
        const idParam = this.route.snapshot.paramMap.get('idLogIntegracao');
        if (idParam) {
            const idLogIntegracao = parseInt(idParam, 10);
            this.carregarLog(idLogIntegracao);
        } else {
            this.alertService.show('Erro', 'ID do log não fornecido.', AlertType.error);
            this.voltar();
        }
    }

    carregarLog(id: number): void {
        this._isLoading = true;
        this.logIntegracaoService.getLogPorId(id).subscribe({
            next: (response: GetLogIntegracaoResponse) => {
                this._isLoading = false;
                if (response.isError || !response.logIntegracao) {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                    this.voltar();
                    return;
                }

                this.log = response.logIntegracao;
                this.formatarJsons();
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro Inesperado', 'Não foi possível carregar os detalhes do log.', AlertType.error);
                this.voltar();
            }
        });
    }

    formatarJsons(): void {
        this.requestJsonFormatado = this.formatarJsonString(this.log?.jsonRequest);
        this.responseJsonFormatado = this.formatarJsonString(this.log?.jsonResponse);
    }

    private formatarJsonString(jsonString: string | undefined | null): string {
        if (!jsonString) {
            return 'Nenhum conteúdo para exibir.';
        }
        try {
            const parsedJson = JSON.parse(jsonString);
            return JSON.stringify(parsedJson, null, 2); // 2 espaços de indentação
        } catch (e) {
            return jsonString;
        }
    }

    copiarJson(conteudo: string): void {
        if (conteudo.startsWith('Nenhum') || conteudo.startsWith('Erro')) {
            return;
        }
        this.clipboard.copy(conteudo);
        this.alertService.show('Sucesso', 'Conteúdo copiado para a área de transferência!', AlertType.success);
    }

    voltar(): void {
        this.router.navigate(['/integracao/logs']);
    }
}